import { useMemo } from 'react';
import { useCardContextValue } from '../state/CardContext';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { getPropertyValue } from '../utils/properties';
import { Avatar } from 'avatar-components/Avatar';
import { AvatarUploader } from 'avatar-components/AvatarUploader';
import { jsx as _jsx } from "react/jsx-runtime";
const AVATAR_KEY_PROPERTY_NAME = 'hs_avatar_filemanager_key';
const AvatarLookup = ({
  size = 'lg'
}) => {
  var _subjectPermissionsRe;
  const {
    objectId,
    objectTypeId,
    asyncData: {
      subjectResult,
      subjectPermissionsResult
    }
  } = useCardContextValue();
  const lookup = useMemo(() => {
    if (!(subjectResult !== null && subjectResult !== void 0 && subjectResult.data)) {
      return undefined;
    }
    if (objectTypeId === CONTACT_TYPE_ID) {
      return {
        type: 'vid',
        primaryIdentifier: objectId,
        email: getPropertyValue(subjectResult.data, 'email'),
        fileManagerKey: getPropertyValue(subjectResult.data, AVATAR_KEY_PROPERTY_NAME)
      };
    }
    if (objectTypeId === COMPANY_TYPE_ID) {
      return {
        type: 'companyId',
        primaryIdentifier: objectId,
        domain: getPropertyValue(subjectResult.data, 'domain'),
        fileManagerKey: getPropertyValue(subjectResult.data, AVATAR_KEY_PROPERTY_NAME)
      };
    }
    return undefined;
  }, [subjectResult, objectId, objectTypeId]);
  if ((_subjectPermissionsRe = subjectPermissionsResult.data) !== null && _subjectPermissionsRe !== void 0 && (_subjectPermissionsRe = _subjectPermissionsRe.crmObject) !== null && _subjectPermissionsRe !== void 0 && _subjectPermissionsRe.userPermissions.currentUserCanEdit && lookup) {
    return /*#__PURE__*/_jsx(AvatarUploader, {
      size: size,
      lookup: lookup
    });
  }
  return /*#__PURE__*/_jsx(Avatar, {
    size: size,
    lookup: lookup
  });
};
export default AvatarLookup;